module.exports = __webpack_public_path__ + "media/images/icons/ic-close-44dd136257049ea99bf35ced1c90e01a.svg";